export const version = "strings/5.1.0";
//# sourceMappingURL=_version.js.map